import { SharedDefectsTable } from "../components/DefectsTable/SharedDefectsTable";

const SharedDefects = () => {
    return (
        <SharedDefectsTable  />
    )
};

export default SharedDefects;